module.exports = __webpack_public_path__ + "media/stylesheets/images/background_polygon/bg_polygon-44781c4908dd009565290175663d2dca.png";